<div class="form-group">
  <div *ngFor="let option of model">
    <spk-checkbox [(model)]="option.Selected" [name]="'selector' + option.Text + option.Value" [wrapped]="false"></spk-checkbox>
    <label class="form-check-label" for="selector{{option.Text}}{{option.Value}}">&nbsp;{{option.Text}}</label>
  </div>
</div>
